const Formation = ({ handleChange, values, formations, handleErreur,campus }) => {
  const getFormation = () => {
        return formations
        ?.filter((formation) => {
            return (
              (
                values.idModaliteSuivi == 121584 /*En ligne*/ &&
                formation.id == 1400093/*formation POE en ligne*/ 
              ) 
              ||
              (
                values.idModaliteSuivi == 121581 /*Présentiel*/ &&
                values.idCampus == 16 && /*Nantes*/
                formation.id == process.env.REACT_APP_ID_TECHNICIEN_HELPDESK/*formation Technicien HelpDesk*/ 
              )               
              ||
              (formation.id != 1400093 && formation.id != process.env.REACT_APP_ID_TECHNICIEN_HELPDESK)
              
            );
        })
        ?.map((formation) => {
            return <option value={formation.id}>{formation.libelle} </option>;
        });
  };

  if (values.idFiliere > 0) {
    return (
      <div class="d-flex flex-column mt-sm-0 mt-4">
        <label>Quelle formation vous intéresse ?*</label>
        <select
          type="text"
          value={values.idFormation}
          onChange={handleChange("idFormation")}
          id="idFormation"
        >
          <option value="0" selected="selected"></option>
          {getFormation()}
        </select>
        {handleErreur("idFormation")}
      </div>
    );
  } else {
    return <></>;
  }
};

export default Formation;
